import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import ProductCardCartV2 from "../product/ProductCardCartV2";
import UpsellingRow from "../../../components/UpsellingRow";
import { useLocation } from "react-router";
import { CartSuggestionIndicator } from "../components/CartSuggestionIndicator";

const useStyles = makeStyles((theme: Theme) => ({
	container: {
		padding: theme.spacing(1),
		position: "relative",
		zIndex: 10,
	},
	upsellingRow: {
		marginTop: "30px"
	}
}));

const Cart = (props: CartProps) => {
	const classes = useStyles();
	const cart = useSelector((state) => state.cart);
	const location = useLocation();
	const mySearchParams = new URLSearchParams(location.search);
	const hasUpselling = mySearchParams.get("upselling") === 'true';

	if (!cart) return null;

	return (
		<div className={classes.container}>
			{props.title && (
				<Typography color="primary" variant="h5">
					{props.title}
				</Typography>
			)}
			{cart.items.map((cartItem) => {
				return (
					<ProductCardCartV2
						item={cartItem}
						key={`cart-item-${cartItem.id}`}
					></ProductCardCartV2>
				);
			})}
			{hasUpselling && <UpsellingRow className={classes.upsellingRow}/>}
			<CartSuggestionIndicator/>
		</div>
	);
};

Cart.defaultProps = {
	title: "Il tuo ordine",
} as CartProps;

export interface CartProps {
	title?: string;
}

export default Cart;
